<template>
  <el-form-item :label="$attrs.label" :prop="$attrs.name" class="elsa-input" :ref="$attrs.name">
    <el-select
      v-bind="$attrs"
      v-on="$listeners"
      :class="type"
    >
      <el-option
        v-for="(country, idx) in getCountries"
        :key="idx"
        :label="type === 'country' ? country.name : `+${country.dialCode}`"
        :value="type === 'country' ? country.iso2 : `+${country.dialCode}`"
      >
        <div class="phone-info">
          <span style="float: left; vertical-align: middle" v-if="type === 'country'">{{ country.name }}</span>
          <span style="float: left" v-if="type !== 'country'" :class="`iti-flag ${country.iso2.toLowerCase()}`"></span>
          <span style="float: right; line-height: 21px;" v-if="type !== 'country'">+{{ country.dialCode }}</span>
        </div>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
  import { countries } from '@/helpers/countries'
  import {filter, propEq } from 'ramda'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      type: {
        type: String,
        default: 'country'
      },
    },
    computed: {
      ...mapGetters('user', [
        'countryAdminLevel'
      ]),
      getCountries() {
        if(this.countryAdminLevel)
          return filter(propEq('iso2', this.countryAdminLevel), countries)
        return countries
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_flags.scss';

 .el-form-item.elsa-input {
   display: flex;
   flex-direction: column;
   .el-select {
     width: 100%;
     &.phone {
       width: 85px;
     }
   }
 }

 .phone-info {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

</style>
